import type { IEventBus } from "@/domains/events"
import type { ILockRepository } from "@/domains/lock/interfaces"
import type { LockOnChainTransport } from "@/domains/lock/lock-on-chain-transport"
import type { ITokenLookup } from "@/domains/tokens/types"
import type { IVenammStore } from "@/domains/venamm"

import type { LockVenammQuotesNamespace } from "./types"
import { LockVenammQuoteCache } from "./lock-venamm-quote-cache"
import { LockVenammQuoteService } from "./lock-venamm-quote-service"

export type LockVenammQuotesNamespaceFactoryParams = {
  lockOnChainTransport: LockOnChainTransport
  venammStore: IVenammStore
  tokenLookup: ITokenLookup
  lockRepository: ILockRepository
  eventBus: IEventBus
}

export const LockVenammQuotesNamespaceFactory = {
  create({
    lockOnChainTransport,
    venammStore,
    tokenLookup,
    lockRepository,
    eventBus,
  }: LockVenammQuotesNamespaceFactoryParams): LockVenammQuotesNamespace {
    const cache = new LockVenammQuoteCache()

    const service = new LockVenammQuoteService(
      cache,
      lockOnChainTransport,
      venammStore,
      tokenLookup,
      lockRepository,
      eventBus,
    )

    return {
      Cache: cache,
      Service: service,
    }
  },
}
